import type { OpsRoleBundle } from "../../shared/operations-schemas";
import { abilitiesByArea } from "./permission-language";

export function EmployeeRoleOptions({
  roles,
  selected,
  onChange,
}: {
  roles: OpsRoleBundle[];
  selected: string[];
  onChange: (roleKey: string, checked: boolean) => void;
}) {
  return (
    <fieldset className="space-y-3">
      <legend className="sr-only">Role bundles</legend>
      {roles.map((role) => (
        <label
          className="flex cursor-pointer items-start gap-3 rounded-md border p-4 hover:border-primary"
          key={role.key}
        >
          <input
            checked={selected.includes(role.key)}
            className="mt-1 size-5 accent-[var(--primary)]"
            onChange={(event) => {
              onChange(role.key, event.currentTarget.checked);
            }}
            type="checkbox"
          />
          <span className="min-w-0">
            <span className="block font-semibold">{role.displayName}</span>
            <span className="block text-sm text-muted-foreground">{role.description}</span>
            <span className="mt-1 block text-sm text-muted-foreground">
              {abilitiesByArea(role.permissions)
                .map((group) => group.area)
                .join(", ") || "Grants nothing"}
            </span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
